export default __webpack_public_path__ + "static/media/w_f_2025_a.bcadd7bc.jpg";